export const ROLES = ['ADMIN', 'LEAD', 'AGENT', 'VIEWER'] as const;
export type Role = (typeof ROLES)[number];

// Reihenfolge: 1 = Vermittlung, 2 = Recruiting, 3 = Mandanten, dann GL/Marketing.
export const TEAMS = ['VERMITTLUNG', 'RECRUITING', 'MANDANTEN', 'GL_MARKETING'] as const;
export type Team = (typeof TEAMS)[number];

export const TEAM_LABELS: Record<Team, string> = {
  VERMITTLUNG: 'Vermittlung',
  RECRUITING: 'Recruiting',
  MANDANTEN: 'Mandantenbetreuung',
  GL_MARKETING: 'GL / Marketing',
};
